import React, { useRef, useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useFormPageHandler, useMergeState } from 'irmlib/hooks'
import { XDivider, YDivider, CreateJobIntentContainer, CreateTemplateAccountsIntentContainerSmtCtlg } from 'irmlib/styles'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage'
import TemplateFormat from '../Template/ActivityTemplateFormation.jsx'
import { TextField, CancelButton, SaveButton, Autocomplete, Select } from '../../../irmlib/src/components/FormControls'
import { ContainedButton } from 'irmlib/components/Controls/Button'
import { setBusy, clearBusy, openGeneralDialog, closeGeneralDialog, useSnackbar } from 'irmlib/containers'
import { OutlinedButton } from 'irmlib/components/Controls'
import { useHistory } from 'react-router-dom'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import * as routePaths from '../../../navigation/routePaths'
import { setFormStatusError } from '../../../irmlib/src/redux'
import * as constants from '../../../irmlib/src/common/constants'
import { validateAndGetAccountLevel1, validateAndGetAccountLevel2, validateAndGetAccountLevel3 } from '../../../services/skpApi'
import { getUser } from '../../../redux/global'
import { Box, Typography } from '@material-ui/core'
import { errorToast } from '../../../common/functions'
import { defaultDateFormat2, countryConfig } from '../../../common/constants'
import { useTranslation } from 'react-i18next'
import { InputFileUploadButton } from './UploadButton.jsx'
import { GroupedMenu } from './GroupedMenu.jsx'
import { Card, CardContent } from '@mui/material'
import { storage } from '../../../utils/firestore'
import { getDownloadURL, ref as storageRef, uploadBytes } from 'firebase/storage'
import { validateAccountData } from '../../../services/common/accountValidateApi.js'

const defaultSelectOption = { value: constants.defaultSelect, label: constants.defaultSelect }

const BOX_TRANSMITTAL_ASSET_TYPE = 'Box Transmittal'

/** Returns assetTypes config containing only the Box Transmittal sub-option (for federal Box Transmittal template flow). */
const filterAssetTypesToBoxTransmittalOnly = (assetTypes) => {
  if (!assetTypes || typeof assetTypes !== 'object' || Array.isArray(assetTypes)) return null
  const result = {}
  Object.entries(assetTypes).forEach(([gKey, group]) => {
    if (!group?.isActive) return
    const useSubAsset = Boolean(group.subAssetTypes)
    const rawSubs = group.subAssetTypes || group.subWorkflowTypes
    if (!rawSubs) return
    const btResult = {}
    Object.entries(rawSubs).forEach(([sKey, sub]) => {
      if (sub?.isActive && sub.name === BOX_TRANSMITTAL_ASSET_TYPE) btResult[sKey] = sub
    })
    if (Object.keys(btResult).length === 0) return
    const filteredGroup = { ...group }
    if (useSubAsset) {
      filteredGroup.subAssetTypes = btResult
      delete filteredGroup.subWorkflowTypes
    } else {
      filteredGroup.subWorkflowTypes = btResult
      delete filteredGroup.subAssetTypes
    }
    result[gKey] = filteredGroup
  })
  return Object.keys(result).length ? result : null
}

const VerticalDivider = () =>
  <YDivider height='20px' />

const Buttons = props =>
  <>
    <CancelButton id={'createTemplate_button_cancel'} arrRefs={props.arrRefs} onClick={props.handleCancel} />
    <XDivider width='10px' />
    {props?.showTable && <SaveButton id={'createTemplate_button_save'} disabled={Object.keys(props.validationErrors).length > 0} arrRefs={props.arrRefs} postService={props.handlePageSave} /> }
  </>

Buttons.propTypes = {
  arrRefs: PropTypes.array,
  handlePageSave: PropTypes.func,
  handleCancel: PropTypes.func,
  validationErrors: PropTypes.object,
  showTable: PropTypes.bool,
}

const CancelButtons = props => 
  <>
    <CancelButton id={'createActivity_cancel'} onClick={props.handleCancel} arrRefs={props.arrRefs} />
  </>

CancelButtons.propTypes = {
  handleCancel: PropTypes.func,
  arrRefs: PropTypes.object,

}

const ButtonsForSaveJobsForLater = props =>
  <>
    <CancelButton id={'createActivity_DialogBox_cancel'} arrRefs={props.arrRefs} onClick={closeGeneralDialog} />
    <SaveButton id={'createActivity_DialogBox_saveJob'} arrRefs={props.arrRefs} postService={props.postService} saveLabel='buttons.saveJob' />
  </>

ButtonsForSaveJobsForLater.propTypes = {
  arrRefs: PropTypes.array,
  postService: PropTypes.func
}

const SELECT_ACOUNT_LEVEL1 = 0
const SELECT_ACOUNT_LEVEL2 = 1
const SELECT_ACOUNT_LEVEL3 = 3
// const SELECT_DISTRICT = 4
// const SELECT_BUILDING = 5
// const SELECT_ORDER_NUMBER = 6
// const SELECT_ASSET_TYPE = 4
const SELECT_TEMPLATE_TYPE = 5
const SELECT_LINE_OF_BUSINESS = 6

const SELECT_CUSTOM_TEMPLATE_NAME = 7
const SELECT_WMS_INSTANCE = 8
const SELECT_WMS_REGION = 9



const getService = async (setState) => {
  const getObject = {
  }
  return Promise.resolve(getObject)
}

const initialSate = {
  showTable: false,
  lineOfBusiness: [],
  customTemplateName: [],
  workerDetails: [defaultSelectOption],
  workerDetailsGde: null,
  wmsList: [defaultSelectOption],
  assetType: [],
  templateType: [],
  skpInstance: [defaultSelectOption],
  selectedWms: '',
  selectedWmsRegion: '',
  selectedTemplate: '',
  districts: [defaultSelectOption],
  selectedTemplateValues: [],
  WMSDistrictBuildings: [],
  WMSSystem: null,
  accountLevel1Description: '',
  validationErrors: {},
  openCustomFieldsDialog: false,
  saveStandardTempValues: [],
  addedCustomFields: [],
  renderNewTemplate: false,
  isCustomFieldsNotAdded: true,
  selectedCustomTemplateFields: [],
  selectedCustomTemplateFieldNames: [],
  enableAddFieldsBtn: true,
  isTemplateChanged: false,
  wmsRegion: '',
  wmsRegions: [],
  countryCode: '',
  districtId: '',
  country: '',
  errorMsg: '',
  showForm: false,
  wmsForCountry: '',
  buildings: [],
  templateData: [],
  templateName: '',
  haveExistingRequest: false,
  selectedImage: false,
  selectedImageGsPath: false,
  error: '',
  skpEncoding: {},
  wmsInstances: [],
  federalBoxTransmittalTemplateFlow: false,
}


const CreateActivity = () => {
  const { t } = useTranslation()
  const refLocalBusyCursor = useRef(null)
  const [state, setState, getState] = useMergeState(initialSate)
  const tableRef = useRef()
  const history = useHistory()
  // eslint-disable-next-line no-unused-vars
  const { workerId: customerId, email: customerEmail = '', countryCode, district, role } = getUser()
  // const [open, setOpen] = React.useState(true)
  const [selectedAssetType, setSelectedAssetType] = React.useState(null)
  const snackBar = useSnackbar()

  useEffect(async() => {
    getActivityDetails(customerId)
  }, [])

  const formTemplate = [

    {
      label: 'templates.accountLevelOne',
      fieldKey: 'accountLevel1',
      defaultValue: '',
      isRequired: true
    },
    {
      label: 'templates.accountLevelTwo',
      fieldKey: 'accountLevel2',
      defaultValue: '',
      isDisable: true
    },
    {
      fieldKey: 'obj.obj1.check',
      defaultValue: false
    },
    {
      label: 'templates.accountLevelThree',
      fieldKey: 'accountLevel3',
      defaultValue: '',
      isDisable: true
    },
    // {
    //   label: 'templates.district',
    //   fieldKey: 'districtId',
    //   defaultValue: constants.defaultSelect,
    //   isRequired: true
    // },
    // {
    //   label: 'templates.building',
    //   fieldKey: 'buildingId',
    //   defaultValue: constants.defaultSelect,
    //   isRequired: true
    // },
    // {
    //   label: 'templates.orderNumberRequired',
    //   fieldKey: 'orderNumber',
    //   isRequired: true
    // },
    {
      label: 'templates.assetType',
      fieldKey: 'assetId',
      defaultValue: constants.defaultSelect,
      isRequired: true
    },
    {
      label: 'templates.templateType',
      fieldKey: 'templateType',
      defaultValue: constants.defaultSelect,
      isRequired: true
    },
    {
      label: 'templates.lineOfBusiness',
      fieldKey: 'businessType',
      defaultValue: constants.defaultSelect,
      isRequired: true
    },
    {
      label: 'templates.customTemplateName',
      fieldKey: 'CustomtemplateName',
      // defaultValue: constants.defaultSelect,
      isRequired: true
    },
    {
      label: ('Search.wms'),
      fieldKey: 'wmsInstance',
      defaultValue: constants.defaultSelect,
      isRequired: true
    },
    {
      label: ('Search.wmsRegion'),
      fieldKey: 'wmsRegion',
      defaultValue: constants.defaultSelect,
      isRequired: true
    }
  ]
 

  const [arrRefs, data] = useFormPageHandler({
    formTemplate,
    service: getService,
    busyOverride: refLocalBusyCursor,
  })


  // const getDistricts = async () => {
  //   const collection = await gdeTransactions.getLocationsForCountry(getState().country)
  //   const districtsList = [defaultSelectOption]
  //   collection.forEach((doc) => {
  //     districtsList.push({ value: doc.data().districtName, label: doc.data().districtName })
  //   })
  //   setState({ districts: districtsList })
  // }

  const getSkpInstance = async (countryCode) => {
    const doc = await gdeTransactions.getSkpInstance(countryCode)
    const wmsList = []
    if (doc && 'skp' in doc) {
      const skpInstance = doc.skp.instances[0]
      setState({ wmsRegion: skpInstance })
      if (skpInstance !== undefined) {
        wmsList.push({
          value: 'SKP', label: 'SKP'
        })
      }
    }
    if (doc && 'oneil' in doc) {
      const oneilInstance = doc.oneil.instances
      const instances = oneilInstance.map((key) => ({ value: key, label: key }))
      setState({ wmsRegions: instances })
      if (instances?.length > 0) {
        wmsList.push({
          value: 'ONEIL', label: 'ONEIL'
        })
      }
    }

    setState({
      wmsInstances: wmsList
    })
  }

  // const getBuildings = async (district) => {
  //   if (district && district !== constants.defaultSelect) {
  //     const buildingsSnapshot = await gdeTransactions.getBuildingForDistrict(district)
  //     const buildings = Object.entries(buildingsSnapshot)?.map(([key, value]) => ({ value: key, label: value }))
  //     setState({ buildings: buildings }) 
  //   }
  // }

  const getActivityDetails = async (userId) => {
    setBusy()
    const workerDetails = await gdeTransactions.getWorkerDetails(userId)
    const workerDetailsGde = await gdeTransactions.getWorkerRoleGde(userId)
    const [lineOfBusiness, assetType, , templateType, customTemplateName] = await gdeTransactions.getGdeConfig()
    const countryCode = workerDetailsGde?.gdeCountryCode || workerDetails.countryCode
    await getSkpInstance(countryCode)
    // await getBuildings(workerDetailsGde?.district[0])
    const lineOfBusinessData = Object.entries(lineOfBusiness).map(([key, value]) => ({ value: value.name, label: value.name }))
    const templateTypeData = Object.entries(templateType).map(([key, value]) => ({ value: value.name, label: value.name }))
    const customTemplateNameData = Object.entries(customTemplateName).map(([key, value]) => ({ value: value.name, label: value.name }))
    // const wmsInstances = Object.entries(wmsConfig).map(([key, value]) => ({ value: value.name, label: value.name }))

    setState(
      { 
        workerDetails: workerDetails, 
        countryCode: countryCode, 
        districtId: workerDetails?.gdeDistrict, 
        country: workerDetailsGde?.gdeCountry,
        lineOfBusiness: lineOfBusinessData,
        customTemplateName: customTemplateNameData,
        assetType: assetType,
        templateType: templateTypeData,
        // wmsInstances: wmsInstances
      })
    // arrRefs[SELECT_DISTRICT]?.current?.setValue(workerDetails?.gdeDistrict)
    arrRefs[SELECT_WMS_INSTANCE].current.focus()
    arrRefs[SELECT_LINE_OF_BUSINESS]?.current?.setValue('NA')
    // await getDistricts()
    clearBusy()
  }

  const validateAccountLevel1 = async (value, bypassFederalCheck = false) => {
    if (value !== '') {
      setBusy()
      const isFederalCustomer = bypassFederalCheck
        ? false
        : await gdeTransactions.getFederalCustomers(value, '', '')
      const isOffshoreCustomer = bypassFederalCheck
        ? false
        : await gdeTransactions.getOffshoreExcludedCustomers(value, '', '')
      if (isFederalCustomer && !isOffshoreCustomer) {
        setState({ errorMsg: t('smartCatalog.smartErr') })
        clearBusy()
      } else {
        validateAndGetAccountLevel1(getState()?.wmsRegion, value)
          .then(async (result) => {
            if (result) {
              const errors = getState().validationErrors
              if (result.error) {
                errors[SELECT_ACOUNT_LEVEL1] = result.error
                setState({ validationErrors: errors, errorMsg: result.error })
              }
              if (result.success && result.statusCode === 200) {
                delete errors[SELECT_ACOUNT_LEVEL1]
                setState({ validationErrors: errors, showForm: true, errorMsg: '', resetBtn: true })
                arrRefs[SELECT_ACOUNT_LEVEL1].current.clearErrorMsg()
                arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(true)
                arrRefs[SELECT_ACOUNT_LEVEL2].current.setDisabled(true)
                arrRefs[SELECT_ACOUNT_LEVEL1].current.setDisabled(true)
                arrRefs[SELECT_WMS_INSTANCE].current.setDisabled(true)
                // arrRefs[SELECT_DISTRICT].current.focus()
                // arrRefs[SELECT_CUSTOM_TEMPLATE_NAME].current.focus()

                setState({ accountLevel1Description: result.accountLevel1Description })
              }
              clearBusy()
            }
          })
      }
    } else {
      arrRefs[SELECT_ACOUNT_LEVEL1].current.setErrorMsg('Required', true)
      arrRefs[SELECT_ACOUNT_LEVEL2].current.clear()
      arrRefs[SELECT_ACOUNT_LEVEL3].current.clear()
      arrRefs[SELECT_ACOUNT_LEVEL2].current.setDisabled(true)
      arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(true)
      arrRefs[SELECT_WMS_INSTANCE].current.setDisabled(true)
      clearBusy()
    }
  }


  const validateAccountLevel2 = async (value, bypassFederalCheck = false) => {
    const accntLvl1 = arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue()
    const accntLvl3 = arrRefs[SELECT_ACOUNT_LEVEL3].current.getValue()
    if (arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue() !== '') {
      setBusy()
      const isFederalCustomer = bypassFederalCheck
        ? false
        : await gdeTransactions.getFederalCustomers(accntLvl1, value, accntLvl3)
      const isOffshoreCustomer = bypassFederalCheck
        ? false
        : await gdeTransactions.getOffshoreExcludedCustomers(accntLvl1, value, accntLvl3)
      if (isFederalCustomer && !isOffshoreCustomer) {
        setState({ errorMsg: t('smartCatalog.smartErr') })
        clearBusy()
      } else {
        validateAndGetAccountLevel2(getState()?.wmsRegion, arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue(), value)
          .then(async (result) => {
            const errors = getState().validationErrors
            if (result) {
              if (result.error) {
                errors[SELECT_ACOUNT_LEVEL2] = result.error
                setState({ validationErrors: errors, errorMsg: result.error })
              }
              if (result.success && result.statusCode === 200) {
                delete errors[SELECT_ACOUNT_LEVEL2]
                setState({ validationErrors: errors, showForm: true, errorMsg: '', resetBtn: true })
                arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(true)
                arrRefs[SELECT_ACOUNT_LEVEL2].current.setDisabled(true)
                arrRefs[SELECT_WMS_INSTANCE].current.setDisabled(true)
                arrRefs[SELECT_ACOUNT_LEVEL1].current.setDisabled(true)
                arrRefs[SELECT_ACOUNT_LEVEL2].current.clearErrorMsg()
                arrRefs[SELECT_ACOUNT_LEVEL3].current.clear()
              // arrRefs[SELECT_DISTRICT].current.focus()
              }
              clearBusy()
            }
          })
      }
    } else {
      arrRefs[SELECT_ACOUNT_LEVEL2].current.setErrorMsg('Account Level 1/ Customer Required', true)
      clearBusy()
    }
  }

  const validateAccountLevel3 = async (value, bypassFederalCheck = false) => {
    if (arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue() !== '') {
      setBusy()
      const accountLevel1 = arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue()
      const accountLevel2 = arrRefs[SELECT_ACOUNT_LEVEL2].current.getValue()
      const isFederalCustomer = bypassFederalCheck
        ? false
        : await gdeTransactions.getFederalCustomers(accountLevel1, accountLevel2, value)
      const isOffshoreCustomer = bypassFederalCheck
        ? false
        : await gdeTransactions.getOffshoreExcludedCustomers(accountLevel1, accountLevel2, value)
      if (isFederalCustomer && !isOffshoreCustomer) {
        setState({ errorMsg: t('smartCatalog.smartErr') })
        clearBusy()
      } else {
        validateAndGetAccountLevel3(getState()?.wmsRegion, arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue(), arrRefs[SELECT_ACOUNT_LEVEL2].current.getValue(), value)
          .then(async (result) => {
            const errors = getState().validationErrors
            if (result.error) {
              errors[SELECT_ACOUNT_LEVEL3] = result.error
              setState({ validationErrors: errors, errorMsg: result.error })
            } else if (result.success && result.statusCode === 200) {
              delete errors[SELECT_ACOUNT_LEVEL3]
              setState({ validationErrors: errors, showForm: true, errorMsg: '', resetBtn: true })
              arrRefs[SELECT_ACOUNT_LEVEL3].current.clearErrorMsg()
              arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(true)
              arrRefs[SELECT_ACOUNT_LEVEL2].current.setDisabled(true)
              arrRefs[SELECT_ACOUNT_LEVEL1].current.setDisabled(true)
              arrRefs[SELECT_WMS_INSTANCE].current.setDisabled(true)
            // arrRefs[SELECT_DISTRICT].current.focus()
            }
            clearBusy()
          })
      }
    } else {
      clearBusy()
      arrRefs[SELECT_ACOUNT_LEVEL3].current.setErrorMsg('Account Level 1/ Customer is Required', true)
    }
  }

  // const onChangeDistrict = async value => {
  //   setBusy()
  //   if (value && value !== constants.defaultSelect) {
  //     await getBuildings(value)
  //   }
  //   arrRefs[SELECT_BUILDING]?.current?.setValue('')
  //   clearBusy()
  // }

  const openBoxTransmittalFederalConfirmDialog = (runValidationWithBypass) => {
    setState({ errorMsg: '' })
    openGeneralDialog({
      title: t('templates.confirm'),
      message: (
        <Box component='div'>
          <Typography paragraph style={{ color: '#ffffff', backgroundColor: '#db4437', fontSize: '1rem' }}>
            {t('smartCatalog.smartErr')}
          </Typography>
          <Typography style={{ fontSize: '1rem' }}>
            {t('smartCatalog.boxTransmittalTemplateConfirm')}
          </Typography>
        </Box>
      ),
      noTranslateTitle: true,
      buttons: (
        <>
          <OutlinedButton onClick={() => {
            closeGeneralDialog()
            setState({ federalBoxTransmittalTemplateFlow: false, errorMsg: t('smartCatalog.smartErr') })
          }}
          >buttons.no</OutlinedButton>
          <ContainedButton onClick={() => {
            closeGeneralDialog()
            setState({ federalBoxTransmittalTemplateFlow: true })
            runValidationWithBypass(true)
          }}
          >buttons.yes</ContainedButton>
        </>
      ),
      closeX: true
    })
  }

  const handleValidate = async () => {
    const wmsInstance = arrRefs[SELECT_WMS_INSTANCE].current.getValue()
    if (wmsInstance === 'SKP') {
      const accntLvl1 = arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue()
      const accntLvl2 = arrRefs[SELECT_ACOUNT_LEVEL2].current.getValue()
      const accntLvl3 = arrRefs[SELECT_ACOUNT_LEVEL3].current.getValue()
      let runValidation
      let fedA1
      let fedA2
      let fedA3
      if (accntLvl1 !== '' && accntLvl3 !== '') {
        runValidation = (bypass) => validateAccountLevel3(accntLvl3, bypass)
        fedA1 = accntLvl1
        fedA2 = accntLvl2
        fedA3 = accntLvl3
      } else if (accntLvl1 !== '' && accntLvl2 !== '' && accntLvl3 === '') {
        runValidation = (bypass) => validateAccountLevel2(accntLvl2, bypass)
        fedA1 = accntLvl1
        fedA2 = accntLvl2
        fedA3 = accntLvl3
      } else if (accntLvl1 !== '' && accntLvl2 === '' && accntLvl3 === '') {
        runValidation = (bypass) => validateAccountLevel1(accntLvl1, bypass)
        fedA1 = accntLvl1
        fedA2 = ''
        fedA3 = ''
      } else {
        return
      }
      setBusy()
      let isFederal
      let isOffshore
      try {
        isFederal = await gdeTransactions.getFederalCustomers(fedA1, fedA2, fedA3)
        isOffshore = await gdeTransactions.getOffshoreExcludedCustomers(fedA1, fedA2, fedA3)
      } catch {
        return
      } finally {
        clearBusy()
      }
      if (isFederal) {
        openBoxTransmittalFederalConfirmDialog(runValidation)
      } else if (isOffshore) {
        setState({ federalBoxTransmittalTemplateFlow: true })
        runValidation(false)
      } else {
        runValidation(false)
      }
    } else if (wmsInstance === 'ONEIL') {
      if (arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue() !== '') {
        const accntLvl1 = arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue()
        const accntLvl2 = arrRefs[SELECT_ACOUNT_LEVEL2].current.getValue()
        const accntLvl3 = arrRefs[SELECT_ACOUNT_LEVEL3].current.getValue()
        setBusy()
        let isFederal
        let isOffshore
        try {
          isFederal = await gdeTransactions.getFederalCustomers(accntLvl1, accntLvl2, accntLvl3)
          isOffshore = await gdeTransactions.getOffshoreExcludedCustomers(accntLvl1, accntLvl2, accntLvl3)
        } catch {
          return
        } finally {
          clearBusy()
        }
        if (isFederal) {
          openBoxTransmittalFederalConfirmDialog((bypass) => accountLevelValidation(bypass))
        } else if (isOffshore) {
          setState({ federalBoxTransmittalTemplateFlow: true })
          accountLevelValidation(false)
        } else {
          accountLevelValidation(false)
        }
      }
    }
  }

  const accountLevelValidation = async (bypassFederalCheck = false) => {
    setBusy()
    const errors = getState().validationErrors
    const country = getState().country
    const wmsInstance = arrRefs[SELECT_WMS_INSTANCE].current.getValue()
    const wmsRegion = arrRefs[SELECT_WMS_REGION]?.current?.getValue()
    const accntLvl1 = arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue()
    const accntLvl2 = arrRefs[SELECT_ACOUNT_LEVEL2].current.getValue()
    const accntLvl3 = arrRefs[SELECT_ACOUNT_LEVEL3].current.getValue()
    const isFedCust = bypassFederalCheck
      ? false
      : await gdeTransactions.getFederalCustomers(accntLvl1, accntLvl2, accntLvl3)
    const isOffshoreCust = bypassFederalCheck
      ? false
      : await gdeTransactions.getOffshoreExcludedCustomers(accntLvl1, accntLvl2, accntLvl3)
    if (isFedCust && !isOffshoreCust) {
      setState({ errorMsg: t('smartCatalog.smartErr') })
      clearBusy()
    } else {
      const result = await validateAccountData(country, wmsInstance, wmsRegion, accntLvl1, accntLvl2, accntLvl3)
      if (result === 'success') {
        delete errors[SELECT_ACOUNT_LEVEL1]
        setState({ validationErrors: errors, showForm: true, errorMsg: '', resetBtn: true })
        arrRefs[SELECT_ACOUNT_LEVEL1].current.clearErrorMsg()
        arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(true)
        arrRefs[SELECT_ACOUNT_LEVEL2].current.setDisabled(true)
        arrRefs[SELECT_ACOUNT_LEVEL1].current.setDisabled(true)
        arrRefs[SELECT_WMS_INSTANCE].current.setDisabled(true)
        arrRefs[SELECT_WMS_REGION]?.current?.setDisabled(true)
      } else {
        let errorMsg
        if (typeof result === 'string') {
          errorMsg = `API Error: ${result}`
        } else if (typeof result === 'object') {
          // getting some unKnown error that's the reason for adding
          if (!result?.errors?.length) {
            errorMsg = `Error: ${'unknown Error'}`
          } else {
            errorMsg = `Error: ${result?.errors[0]?.error}`
          }        
        }
        errors[SELECT_ACOUNT_LEVEL1] = errorMsg
        setState({ validationErrors: errors, errorMsg: errorMsg })
      }
    }
    clearBusy()
  }

  const handleReset = () => {
    setState({ showForm: false, showTable: false, resetBtn: false, federalBoxTransmittalTemplateFlow: false })
    setSelectedAssetType(null)
    arrRefs[SELECT_ACOUNT_LEVEL1].current.clear()
    arrRefs[SELECT_ACOUNT_LEVEL2].current.clear()
    arrRefs[SELECT_ACOUNT_LEVEL3].current.clear()
    arrRefs[SELECT_ACOUNT_LEVEL1].current.setDisabled(false)
    arrRefs[SELECT_ACOUNT_LEVEL2].current.setDisabled(false)
    arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(false)
    arrRefs[SELECT_WMS_INSTANCE].current.setDisabled(false)
    arrRefs[SELECT_WMS_REGION]?.current?.setDisabled(false)
    arrRefs[SELECT_ACOUNT_LEVEL1].current.focus()
  }

  const handleImageUpload = async(value) => {
    if (value) {
      const imageRef = storageRef(storage, `smartCatalog/gde_refImg_${customerId}_${Date.now()}.jpg`)
      uploadBytes(imageRef, value)
        .then((snapshot) => {
          getDownloadURL(snapshot.ref)
            .then((url) => {
              const gspath = `gs://${snapshot.ref.bucket}/${snapshot.ref.fullPath}`
              setState({
                selectedImage: url,
                selectedImageGsPath: gspath,
              })
              setError('')
            })
            .catch((error) => {
              // eslint-disable-next-line no-console
              console.log(error.message)
            })
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log(error.message)
        })
    } else {
      const error = getState().validationErrors
      setState({ validationErrors: { ...error, btnError: 'Incorrect format or size.' } })
    }
  }

  const onChangeTemplateType = async(value) => {
    // if (value && selectedAssetType) {
    //   let templateName = false
    //   if (value === 'New' && getState()?.selectedWms === 'SKP') {
    //     templateName = 'skpStandardNewFile'
    //     if (selectedAssetType === 'Single Box' || selectedAssetType === 'Multiple Boxes') {
    //       templateName = 'skpStandardNewBox'
    //     }
    //   } else if (value === 'Maintenance' && getState()?.selectedWms === 'SKP') {
    //     templateName = 'skpStandardMaintenanceFile'
    //     if (selectedAssetType === 'Single Box' || selectedAssetType === 'Multiple Boxes') {
    //       templateName = 'skpStandardMaintenanceBox'
    //     }
    //   }

    //   if (value === 'New' && getState()?.selectedWms === 'ONEIL') {
    //     templateName = 'oneilStandardNewFile'
    //     if (selectedAssetType === 'Single Box' || selectedAssetType === 'Multiple Boxes') {
    //       templateName = 'oneilStandardNewBox'
    //     }
    //   } else if (value === 'Maintenance' && getState()?.selectedWms === 'ONeil') {
    //     templateName = 'oNeilStandardMaintenanceFile'
    //     if (selectedAssetType === 'Single Box' || selectedAssetType === 'Multiple Boxes') {
    //       templateName = 'oneilStandardMaintenanceBox'
    //     }
    //   }
    //   console.log(value, templateName, selectedAssetType, getState()?.selectedWms, 'selects')
    if (value && selectedAssetType) {
      const templateName = await gdeTransactions.getStandardTemplateName(getState()?.selectedWms, value, selectedAssetType)
      const templateDataRaw = await gdeTransactions.getTemplateById(templateName)
      const templateData = templateDataRaw.data()
      setState({
        templateData: templateData,
        templateName: templateName,
        haveExistingRequest: false,
        showTable: true, // change
        showForm: true,
      })
    }
  }

  const onChangeAssetType = async(value) => {
    if (value) {
      // if (value === 'Box Transmittal') {
      //   setSelectedAssetType(value)
      //   const templateName = await gdeTransactions.getStandardTemplateName(getState()?.selectedWms, 'Maintenance', value)
      //   const templateDataRaw = await gdeTransactions.getTemplateById(templateName)
      //   const templateData = templateDataRaw.data()
      //   const defValue = getState()?.templateType.find((opt) => opt?.value === 'Maintenance')
      //   arrRefs[SELECT_TEMPLATE_TYPE]?.current?.setValue('Maintenance')
      //   setState({
      //     templateData: templateData,
      //     templateName: templateName,
      //     haveExistingRequest: false,
      //     showTable: true, // change
      //     showForm: true,
      //     boxTrans: defValue
      //   })
      //   arrRefs[SELECT_TEMPLATE_TYPE]?.current?.setDisabled(true)
      // } else {
      //   setSelectedAssetType(value)
      //   setState({
      //     templateData: [],
      //     templateName: '',
      //     showTable: false,
      //     showForm: true,
      //   })
      //   arrRefs[SELECT_TEMPLATE_TYPE].current.clear()
      // }

      setSelectedAssetType(value)
      setState({
        templateData: [],
        templateName: '',
        showTable: false,
        showForm: true,
      })
      arrRefs[SELECT_TEMPLATE_TYPE].current.clear()
    }
  }

  useEffect(() => {
    if (!state.federalBoxTransmittalTemplateFlow || !state.showForm) return
    if (selectedAssetType === BOX_TRANSMITTAL_ASSET_TYPE) return
    onChangeAssetType(BOX_TRANSMITTAL_ASSET_TYPE)
  }, [state.federalBoxTransmittalTemplateFlow, state.showForm, selectedAssetType])

  const getTemplateFields = async () => {
    const fields = getState()?.templateData?.templateFields
    if (fields !== undefined) {
      if (getState()?.templateData?.assetType !== 'BOX TRANSMITTAL') {
        delete fields.skpBoxId
      }
      delete fields.customerId
      let finalArrayFields
      const arrayFields = Object.keys(fields).map((key) => {
        const data = fields[key]
        data.name = key
        return data
      })
      getState().renderNewTemplate && !state.isTemplateChanged
        ? (finalArrayFields = getState().addedCustomFields)
        : (finalArrayFields = arrayFields)
      getState().renderNewTemplate && !state.isTemplateChanged && setState({ showTable: true })
      finalArrayFields.sort((a, b) =>
        a.customOrder > b.customOrder ? 1 : b.customOrder > a.customOrder ? -1 : 0
      )
      !getState().renderNewTemplate ? setState({ selectedCustomTemplateFields: finalArrayFields }) : state.isTemplateChanged && setState({ selectedCustomTemplateFields: finalArrayFields })
      // defaulting date
      const checkCountry = countryConfig.find(entry => entry.countryCode === getState()?.countryCode)
      finalArrayFields.forEach((field) => {
        if (field?.dataType === 'Date') {
          if (checkCountry) {
            field.customFormat = checkCountry.dateFormat
          } else {
            field.customFormat = defaultDateFormat2
          }
        }
      })
      return Promise.resolve(finalArrayFields)
    }
  }

  const ButtonsForAdditionalFieldDialog = () =>
    <>
      <ContainedButton onClick={closeGeneralDialog} >buttons.Ok</ContainedButton>
    </>

  const handleAdditionalFieldPopUp = () => {
    openGeneralDialog({
      title: t('options.aaditionFieldWarning'),
      message: t('options.aaditionFieldMessage'),
      noTranslate: true,
      noTranslateTitle: true,
      buttons: <ButtonsForAdditionalFieldDialog />,
      closeX: true
    })
  }


  const postService = async postObject => {
    const arrPost = tableRef.current.dataManager.data
    // eslint-disable-next-line
    function check(row) {
      return row.tableData.checked === false
    }
    const noFieldSelected = arrPost.every(check)
    if (noFieldSelected) {
      return handleAdditionalFieldPopUp()
    }

    let isBlankCustomFieldName = false
    arrPost.forEach(r => {
      if (r.tableData.checked) {
        if ((r.customName === '' || r.customName === undefined) && !isBlankCustomFieldName) {
          isBlankCustomFieldName = true
        }
      }
    })


    if (isBlankCustomFieldName) {
      errorToast({ message: t('smartCatalog.emptyTemplateField'), title: t('toast.error') })
      return false
    }
    
    const fields = {}
    let checkedFieldsCount = 0
    arrPost.forEach(r => {
      if (r.tableData.checked) {
        const fieldData = {
          format: r.customFormat || r.format,
          isRequired: r.isRequired,
          length: Number(r.customLength),
          fieldId: r.name,
          sampleValue: r.defaultValue,
          hasSample: Boolean(r.defaultValue),
          doNotDuplicate: r.doNotDuplicate,
          verify: r.verify,
          isLocked: false,
          lockedValue: '',
          instructions: r.instructionData,
        }
        fields[r.customName.split(' ').join('')] = fieldData
        checkedFieldsCount++
      }
    })
    
    
    if (fields && checkedFieldsCount > 0 && Object.keys(fields).length === checkedFieldsCount) {
      const timeNow = Date.now()
      const documentId = timeNow.toString()
      const data = {
        accountLevel1: postObject.accountLevel1.toUpperCase(),
        accountLevel2: postObject.accountLevel2.toUpperCase(),
        accountLevel3: postObject.accountLevel3.toUpperCase(),
        assetType: selectedAssetType,
        templateType: postObject.templateType,
        district: district,
        boxId: null,
        countryCode: getState()?.countryCode,
        templateName: getState()?.templateName,
        createdTS: (new Date()).toISOString(),
        requestId: documentId,
        imgReference: getState().selectedImage ? getState().selectedImage : '',
        imgReferenceURI: getState().selectedImageGsPath ? getState().selectedImageGsPath : '',
        lob: postObject.businessType,
        customTemplateName: postObject.CustomtemplateName,
        // orderId: postObject.orderNumber,
        building: '',
        remarks: '',
        srcSystem: 'gde',
        status: 'pending',
        totalBoxes: null,
        totalFiles: null,
        updatedTS: (new Date()).toISOString(),
        workerId: getState()?.workerDetails?.workerId,
        template: fields,
        isTemplate: true,
        refRequestId: null,
        isProcessed: false,
        isPublished: false,
        isActive: true,
        wmsCode: postObject.wmsInstance.toUpperCase(),
        wmsRegion: postObject.wmsInstance.toUpperCase() === 'SKP' ? getState()?.wmsRegion : getState()?.selectedWmsRegion
      }
      if (getState().selectedImage) {
        await gdeTransactions.createSmartCatalogTemplate(documentId, data)
        const newErrors = { ...getState().validationErrors }
        const currentErrors = getState().validationErrors
        const { btnError, ...remainingErrors } = currentErrors
        setState({ validationErrors: remainingErrors })
        setState({ validationErrors: newErrors })
        setTimeout(snackBar(t('toast.templateCreated', { requestId: documentId })), 50000)
        history.push(routePaths.viewTemplate)
      } else {
        setFormStatusError()
        setError('Please upload an image.')
        setState({ validationErrors: { ...getState().validationErrors, btnError: 'Please upload an image.' } })
      }
    } else {
      errorToast({ message: t('toast.duplicateTemplateField'), title: t('toast.error') })
    }
  }

  const handleCancel = () => {
    openGeneralDialog({
      title: t('templates.cancel'),
      message: t('options.cancelJobMessage'),
      noTranslate: true,
      noTranslateTitle: true,
      buttons: <ButtonsForCancelDialogBox />,
      closeX: true
    })
  }

  const ButtonsForCancelDialogBox = () =>
    <>
      <OutlinedButton onClick={closeGeneralDialog} >buttons.no</OutlinedButton>
      <ContainedButton onClick={handleCancelButtonOnClick} >buttons.yes</ContainedButton>
    </>

  const handleCancelButtonOnClick = () => {
    closeGeneralDialog()
    history.push(routePaths.viewTemplate)
  }

  const setError = (value) => {
    setState({ error: value })
    if (value === '') {
      const currentErrors = getState().validationErrors
      const { btnError, ...remainingErrors } = currentErrors
      setState({ validationErrors: remainingErrors })
    }
  }

  const selectWms = (value) => {
    setState({ selectedWms: value })
  }

  const selectWmsRegion = (value) => {
    setState({ selectedWmsRegion: value })
  }

  const assetTypesForGroupedMenu = useMemo(() => {
    if (!state.federalBoxTransmittalTemplateFlow) return state.assetType
    const filtered = filterAssetTypesToBoxTransmittalOnly(state.assetType)
    return filtered && Object.keys(filtered).length ? filtered : state.assetType
  }, [state.federalBoxTransmittalTemplateFlow, state.assetType])

  state.templateType.forEach((element, index) => {
    if (element.label !== '--Select--') {
      element.label = t(`dropdowns.${element.value}`)
    }
  })
  state.lineOfBusiness.forEach((element, index) => {
    if (element.label !== '--Select--') {
      element.label = t(`dropdowns.${element.value}`)
    }
  })

  return (
    <>
      <MainRouteSubRoutePage
        // mainTitle='routeTitles.jobManagement'
        subTitle='routeTitles.createSmartCatalogSubTitle'
        // createJobParams={['Activities', 'Add Smart Catalog Request']}
        buttons={getState()?.showForm && <Buttons arrRefs={arrRefs} handleCancel={handleCancel} handlePageSave={postService} showTable={getState()?.showTable} validationErrors={getState().validationErrors} />} createPage={true}
      >
        <Card style={{ width: '90vw', margin: '0.5rem' }}>
          <CardContent>
            <CreateTemplateAccountsIntentContainerSmtCtlg>
              <Select
                id={'templateSearch_wms'}
                // onChange={getWms}
                data={data}
                items={state?.wmsInstances}
                fieldTemplate={formTemplate[SELECT_WMS_INSTANCE]}
                ref={arrRefs[SELECT_WMS_INSTANCE]}
                onChange={selectWms}
                noTranslateItems
                noTranslate={true}
              />
              {getState()?.selectedWms === 'ONEIL' &&
                <Select
                  id={'createActivity_wmsRegion'}
                  data={data}
                  items={state?.wmsRegions}
                  fieldTemplate={formTemplate[SELECT_WMS_REGION]}
                  ref={arrRefs[SELECT_WMS_REGION]}
                  onChange={selectWmsRegion}
                  noTranslateItems
                  noTranslate={true}
                />
              }
              <TextField
                id={'createActivity_accountLevel'}
                data={data}
                fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL1]}
                ref={arrRefs[SELECT_ACOUNT_LEVEL1]}
            />
              <TextField
                id={'createActivity_accountLeve2'}
                data={data}
                fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL2]}
                ref={arrRefs[SELECT_ACOUNT_LEVEL2]}
            />
              <TextField
                id={'createActivity_department'}
                data={data}
                fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL3]}
                ref={arrRefs[SELECT_ACOUNT_LEVEL3]}
            />
              {getState()?.resetBtn 
                ? <OutlinedButton onClick={() => handleReset()} style={{ width: '100px', height: '36.5px' }}>buttons.Reset</OutlinedButton>
                : <ContainedButton onClick={() => handleValidate()} style={{
                  width: '100px',
                  height: '36.5px'
                }}>buttons.validate</ContainedButton>}
            </CreateTemplateAccountsIntentContainerSmtCtlg>
            {getState()?.errorMsg && <Typography paragraph={true} style={{ fontSize: '16px', color: '#FFF', backgroundColor: '#db4437', width: 'fit-content', padding: '1px' }}>{getState()?.errorMsg}</Typography>} 
          </CardContent>
        </Card>
        <Box component='div' style={{ backgroundColor: '#F3F3F3', width: '100%', height: '1rem', margin: 0, padding: 0 }} />
         {getState().showForm && (
        <Card style={{ width: '70vw', margin: '0.5rem' }}>
          <CardContent>
            <CreateJobIntentContainer>
              {/* <Select
                id={'createActivity_district'}
                onChange={onChangeDistrict}
                data={data}
                items={state.districts}
                fieldTemplate={formTemplate[SELECT_DISTRICT]}
                ref={arrRefs[SELECT_DISTRICT]}
                noTranslateItems
              />
              <Autocomplete
                id={'createActivity_building'}
                data={data}
                options={state.buildings}
                fieldTemplate={formTemplate[SELECT_BUILDING]}
                ref={arrRefs[SELECT_BUILDING]}
                // onChange={onChangeTemplate}
                noTranslateItems
              /> */}
              {/* <TextField 
                id={'createActivity_orderNumber'} 
                data={data} 
                fieldTemplate={formTemplate[SELECT_ORDER_NUMBER]} 
                ref={arrRefs[SELECT_ORDER_NUMBER]} 
              /> */}
              <GroupedMenu
                key={state.federalBoxTransmittalTemplateFlow ? 'createActivity_assetType_bt' : 'createActivity_assetType_all'}
                id={'createActivity_assetType'}
                data={data}
                assetTypes={assetTypesForGroupedMenu}
                label= {t('templates.assetType')}
                onSelect={onChangeAssetType}
                selected={state.federalBoxTransmittalTemplateFlow ? BOX_TRANSMITTAL_ASSET_TYPE : undefined}
                disableSelect={state.federalBoxTransmittalTemplateFlow}
              />
              <Autocomplete
                id={'createActivity_templateType'}
                data={data}
                value={getState()?.boxTrans || null}
                options={state?.templateType}
                fieldTemplate={formTemplate[SELECT_TEMPLATE_TYPE]}
                ref={arrRefs[SELECT_TEMPLATE_TYPE]}
                onChange={onChangeTemplateType}
                // onSelect={(e) => onChangeTemplateType(e.target.value)}
                noTranslateItems
              />
              <Autocomplete
                id={'createActivity_lineOfBusiness'}
                data={data}
                options={state.lineOfBusiness}
                fieldTemplate={formTemplate[SELECT_LINE_OF_BUSINESS]}
                ref={arrRefs[SELECT_LINE_OF_BUSINESS]}
                noTranslateItems
              />
              <TextField
                
                id={'createActivity_customTemplateName'}
                data={data}
                fieldTemplate={formTemplate[SELECT_CUSTOM_TEMPLATE_NAME]}
                ref={arrRefs[SELECT_CUSTOM_TEMPLATE_NAME]}
                
            />

              <InputFileUploadButton onImageCapture={handleImageUpload} error={getState().error} setError={setError} maxSize={5} allowedFormats = {['JPG', 'JPEG']} />
            </CreateJobIntentContainer>
          </CardContent>
        </Card>
         )}
        {getState().showTable
          ? (
            <Box component='div' style={{ margin: '0.5rem' }}>
              <VerticalDivider />
              <TemplateFormat
                tableRef={tableRef}
                getPageData={getTemplateFields}
                title={getState().templateName}
                skpEncoding={getState()?.skpEncoding}
                wms={getState()?.selectedWms}
                modify={false}
                // setSelectedTemplateValues={saveTemplateValues}
                formTemplates={formTemplate}
                arrRefs={arrRefs}
                isEdit={false}
                getState={getState}
              />
            </Box>
            )
          : null}
      </MainRouteSubRoutePage>
    </>
  )
}

export default CreateActivity
